import Dexie from 'dexie'

import { stores } from './tables'

let database: Dexie | null = null

const databaseName = 'collector-desktop'

export function initDatabase(): void {
  database = new Dexie(databaseName)

  database.version(5).stores(stores)
  ;(async () =>
    // eslint-disable-next-line
    console.debug(`storage estimate`, await navigator.storage.estimate()))()
}

export async function deleteDatabase(): Promise<void> {
  if (database) {
    await database.delete()
    database = null
  }
}

// TODO: replace getDatabase() - import {Database} with proxy
export function getDatabase(): Dexie {
  if (!database) {
    throw new Error(`${databaseName} database not initialized`)
  }

  return database
}
